import { render, staticRenderFns } from "./DuplicateCategory.vue?vue&type=template&id=b9761e2c&scoped=true&"
import script from "./DuplicateCategory.vue?vue&type=script&lang=js&"
export * from "./DuplicateCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9761e2c",
  null
  
)

export default component.exports